<div class="antepost-container" data-crlat="race.antepost">
    <switchers data-crlat="switchers" [filter]="filter" [switchers]="sortSwitchers"> </switchers>
    @for (type of eventsMap[filter!].typeNames; track trackById(index, type); let index = $index) {
        <accordion
            [accordionTitle]="type.typeName"
            [isExpanded]="isExpanded[index]"
            (function)="accordionHandler(index, type)"
            data-crlat="outerAccordion">
            <accordion-body>
                @for (event of type.typeNameEvents; track trackById(i, event); let i = $index) {
                    <list-card
                        (click)="closeOverlay(event)"
                        data-crlat="race.antepost.event"
                        [item]="event"
                        [link]="event.link"
                        [date]="event.date + ' ' + type.typeName"></list-card>
                }
            </accordion-body>
        </accordion>
    }
</div>
